import { z } from 'zod';

export const coverageStateSchema = z.object({
  stateCode: z.string().min(2).max(2),
  allCounties: z.boolean(),
  countyIds: z.array(z.string()).optional().default([]),
});

/**
 * Per-specialty coverage + delivery modes (Admin/SP editor round-trip).
 * `coverageScope: null` means "not configured" — the editor never fills it
 * in by inherit or default (issue 15/24); it blocks save until the admin
 * explicitly picks a scope and at least one delivery mode.
 */
export const specialtyCoverageItemSchema = z
  .object({
    specialtyId: z.string().min(1, 'Specialty is required'),
    coverageScope: z.enum(['NATIONAL', 'REGIONAL']).nullable(),
    serviceRanges: z
      .array(z.enum(['IN_OFFICE', 'VIRTUAL', 'IN_HOME']))
      .min(1, 'At least one delivery mode is required'),
    coverageStates: z.array(coverageStateSchema).default([]),
    isPersisted: z.boolean().optional(),
  })
  .superRefine((item, ctx) => {
    if (item.coverageScope === null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Coverage scope is required',
        path: ['coverageScope'],
      });
      return;
    }
    if (item.coverageScope === 'NATIONAL' && item.coverageStates.length > 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'National coverage cannot include states',
        path: ['coverageStates'],
      });
    }
    if (item.coverageScope === 'REGIONAL' && item.coverageStates.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Regional coverage requires at least one state',
        path: ['coverageStates'],
      });
    }
    item.coverageStates.forEach((state, index) => {
      if (!state.allCounties && (!state.countyIds || state.countyIds.length === 0)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Select at least one county when All counties is off',
          path: ['coverageStates', index, 'countyIds'],
        });
      }
    });
  });
